import { render, staticRenderFns } from "./parent-change.vue?vue&type=template&id=78684ec4&scoped=true"
import script from "./parent-change.vue?vue&type=script&lang=js"
export * from "./parent-change.vue?vue&type=script&lang=js"
import style0 from "./parent-change.vue?vue&type=style&index=0&id=78684ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78684ec4",
  null
  
)

export default component.exports